document.addEventListener('DOMContentLoaded', function () {
  const tabButtons = document.querySelectorAll('.event-tab-button');
  const tabContents = document.querySelectorAll('.event-tab-content');

  if (tabButtons.length && tabContents.length) {
    tabButtons.forEach(button => {
      button.addEventListener('click', function () {
        const selectedTab = this.getAttribute('data-tab');

        tabButtons.forEach(btn => btn.classList.remove('active'));
        this.classList.add('active');

        tabContents.forEach(content => {
          content.style.display = (content.id === selectedTab) ? 'block' : 'none';
        });
      });
    });

    tabButtons[0].classList.add('active');
    const firstTab = tabButtons[0].getAttribute('data-tab');
    tabContents.forEach(content => {
      content.style.display = (content.id === firstTab) ? 'block' : 'none';
    });
  }
});
